// Bundled release metadata. Populated at build time by the
// `qualz-release-metadata` plugin in vite.config.js.
//
// Consumers import `releaseMetadata` for telemetry tagging.
// `publishReleaseMetadata()` exposes the same values to the browser
// (window global, <html> data-* attributes, <head> meta tags) so that
// the running build is identifiable from DevTools without a network call.
//
// The matching `release.json` asset is emitted alongside the bundle
// for verification via `https://<host>/release.json`.

/* global __QUALZ_RELEASE_METADATA__ */
export const releaseMetadata = __QUALZ_RELEASE_METADATA__;

let published = false;

function upsertMetaTag(name, content) {
  const existing = document.head.querySelector(`meta[name="${name}"]`);
  const tag = existing ?? document.createElement('meta');

  tag.name = name;
  tag.content = content;

  if (!existing) {
    document.head.appendChild(tag);
  }
}

export function publishReleaseMetadata() {
  if (published || typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  window.__QUALZ_RELEASE__ = releaseMetadata;
  document.documentElement.dataset.releaseSha = releaseMetadata.releaseSha;
  document.documentElement.dataset.releaseRef = releaseMetadata.releaseRef;
  document.documentElement.dataset.releaseEnv = releaseMetadata.environment;

  upsertMetaTag('qualz:app', releaseMetadata.appName);
  upsertMetaTag('qualz:environment', releaseMetadata.environment);
  upsertMetaTag('qualz:release-sha', releaseMetadata.releaseSha);
  upsertMetaTag('qualz:release-ref', releaseMetadata.releaseRef);
  upsertMetaTag('qualz:generated-at', releaseMetadata.generatedAt);
  upsertMetaTag('qualz:backend-origin', releaseMetadata.backendOrigin);

  console.info('[Qualz release]', releaseMetadata);
  published = true;
}
